;

function logIn() {

    // Log in
    $('.js-log-in').each(function () {
        var container = $(this),
            trigger = $(this).find('a'),
            menu = $(this).find('.umenu')

        $(document).click(function () {
            $(container).removeClass('is-active')
        })

        $(trigger).click(function (e) {
            e.stopPropagation()
            $(this).closest(container).toggleClass('is-active')
        })

        $(menu).find('a').click(function (e2) {
            e2.stopPropagation()
        })
    })

}


(function($) {

    logIn()
    // also called from ajax/header.html.twig

}(jQuery));
